/* eslint-disable */

export default base64 =>
  atob(base64)
    .split('')
    .map(aChar => ('0' + aChar.charCodeAt(0).toString(16)).slice(-2))
    .join('')
    .toUpperCase();
